export default {
  getLookups: (data = null) => $nuxt.$axios.get($nuxt.$api.host + '/lookups', data),
  deleteLookup: (uuid) => $nuxt.$axios.delete($nuxt.$api.host + '/lookups/' + uuid),
  findLookup: (type, value) => $nuxt.$axios.get($nuxt.$api.host + '/lookups/' + type + '/' + value),
}
